/**
 * Allows user to multi-select a group of elements in editor with a single click.
 *
 * Arg:
 *      name { String }: Name of group.
 *
 *  Example:
 *      // groups button and div by the name 'list-item'; groups the spans with the name 'main':
 *      <button v-group:list-item></button>
 *      <div v-group:list-item></div>
 *      <span v-group:main></span>
 *      <span v-group:main></span>
 */
export default {
    inserted(el, binding, vnode) {
        vnode.context.groups[binding.arg] = vnode.context.groups[binding.arg] || [];
        vnode.componentInstance.group = vnode.context.groups[binding.arg];
        vnode.context.groups[binding.arg].push(vnode.componentInstance);
    },
};
